import { render, staticRenderFns } from "./AffResearch.vue?vue&type=template&id=1c252102&scoped=true"
import script from "./AffResearch.vue?vue&type=script&lang=js"
export * from "./AffResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c252102",
  null
  
)

export default component.exports